exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mask[data-v-23e3a30d]{position:fixed;display:block;z-index:100;width:100%;height:100%;top:0;left:0;background-color:rgba(0,0,0,.7)}.mask .icon[data-v-23e3a30d]{position:fixed;right:6.66667vw;top:6.66667vw;width:28vw;height:30.13333vw}.mark-tips[data-v-23e3a30d]{font-size:4.8vw;color:#fff;margin-top:40vw;margin-left:24.8vw}", ""]);

// exports
